import React from 'react';

import { ta } from '../../i18n/adminT';
// Genera l'elenco di pagine da mostrare, con "…" per i tratti saltati.
// Mostra sempre prima, ultima, la pagina corrente e una di margine attorno ad essa.
function buildPageList(current, total) {
  const pages = [];
  const add = (p) => { if (!pages.includes(p)) pages.push(p); };

  add(1);
  for (let p = current - 1; p <= current + 1; p++) {
    if (p > 1 && p < total) add(p);
  }
  if (total > 1) add(total);

  pages.sort((a, b) => a - b);

  const withGaps = [];
  let prev = null;
  for (const p of pages) {
    if (prev !== null && p - prev > 1) withGaps.push('gap');
    withGaps.push(p);
    prev = p;
  }
  return withGaps;
}

// Dimensioni pagina selezionabili (devono coincidere con quelle accettate dal server)
export const PAGE_SIZE_OPTIONS = [20, 50, 100];

// Props facoltative per il selettore "Righe per pagina": pageSize,
// onPageSizeChange e total (numero totale di righe). Senza onPageSizeChange
// il componente si comporta come prima.
export default function Pagination({ page, totalPages, onChange, pageSize, onPageSizeChange, total = 0 }) {
  // Il selettore serve solo se ci sono più righe della dimensione minima;
  // resta visibile anche con una sola pagina, per poter tornare a una
  // dimensione più piccola dopo averne scelta una grande.
  const showSizeSelect = Boolean(onPageSizeChange) && total > PAGE_SIZE_OPTIONS[0];
  if (totalPages <= 1 && !showSizeSelect) return null;

  const pageList = buildPageList(page, totalPages);

  const nav = totalPages > 1 && (
    <nav className="pagination" aria-label={ta('Paginazione')}>
      <button
        type="button"
        className="pagination-nav"
        onClick={() => onChange(page - 1)}
        disabled={page <= 1}
        aria-label={ta('Pagina precedente')}
      >
        ‹
      </button>

      {pageList.map((p, i) =>
        p === 'gap' ? (
          <span key={`gap-${i}`} className="pagination-ellipsis">…</span>
        ) : (
          <button
            key={p}
            type="button"
            className={`pagination-page ${p === page ? 'active' : ''}`}
            onClick={() => onChange(p)}
            aria-current={p === page ? 'page' : undefined}
          >
            {p}
          </button>
        )
      )}

      <button
        type="button"
        className="pagination-nav"
        onClick={() => onChange(page + 1)}
        disabled={page >= totalPages}
        aria-label={ta('Pagina successiva')}
      >
        ›
      </button>
    </nav>
  );

  if (!onPageSizeChange) return nav;

  return (
    <div className="pagination-bar">
      {showSizeSelect ? (
        <label className="pagination-size">
          {ta('Righe per pagina')}
          <select value={pageSize} onChange={(e) => onPageSizeChange(parseInt(e.target.value, 10))}>
            {PAGE_SIZE_OPTIONS.map((n) => <option key={n} value={n}>{n}</option>)}
          </select>
        </label>
      ) : <span />}
      {nav}
    </div>
  );
}
